const usertypes = ['SET_USER', 'UPDATE_USER', 'UPDATE_USER_PREFERENCES', 'CLEAR_USER', 'REGISTER_STEP'];

export default usertypes;
